import { useCallback } from "react";
import { CoachSettings } from "../interfaces";
import { SettingsServices } from "../services";
import { useQuery } from "@tanstack/react-query";
import { useSocialCoachSession } from "./useSocialCoachSession";

export const useCoachSettings = (defaultCoach: number | string | undefined = undefined) => {
  const { coachId } = useSocialCoachSession();
  const effectiveCoachId = defaultCoach || coachId;

  const { data: appSettings } = useQuery({
    queryKey: ["appCoachSettings", coachId],
    queryFn: async () => {
      return SettingsServices.getAppSettingsByCoachId(effectiveCoachId!);
    },
    enabled: !!effectiveCoachId,
    meta: { persist: true },
    staleTime: 1000 * 60, // 1 minute
    gcTime: 1000 * 60 * 60 * 13,
  });

  const hasSetting = useCallback(
    (setting: CoachSettings, defaultIfUndefined: boolean = false): boolean => {
      if (!appSettings) return false;

      const settingStatus = appSettings.settings.find(s => s.appSettingId === setting)?.status;

      return settingStatus ? settingStatus === "ACTIVE" : defaultIfUndefined;
    },
    [appSettings]
  );

  return {
    hasSetting,
  };
};
